import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { bootstrapSession, isAuthenticated, getAdmin } from '../services/auth';
import LoadingSpinner from './common/LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isVerifying, setIsVerifying] = useState(true);
  const [isAuth, setIsAuth] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      // El access token vive en memoria: si ya está, la sesión está activa;
      // si no (recarga de página), se rehidrata vía la cookie de refresh.
      const valid = isAuthenticated() || (await bootstrapSession());
      setIsAuth(valid);
      setIsVerifying(false);
    };

    checkAuth();
  }, []);

  if (isVerifying) {
    return <LoadingSpinner message="Verificando autenticación..." />;
  }

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  const admin = getAdmin();
  if (admin?.mustChangePassword && location.pathname !== '/force-change-password') {
    return <Navigate to="/force-change-password" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
